import '../../styles/Purpose.css';
import '../../styles/Create.css';

export function Boost({ boost }) {

  const hands = `img/${boost.img}`;

  return(
    <div className='columns box is-desktop hero is-warning m-5 apps-boost-container'>
      <div className='column is-two-fifth image-container'>       
            <figure className='image figure-img'>
              <img
                className="image is-rounded"
                src={hands}
                alt='hands'
              />
            </figure>
      </div> 

      <div className='column'>
        <div className='apps-boost-text-background'>
          <p className="card-content is-size-5 has-text-centered">{boost.text}</p>
        </div>
      </div>

    </div>
  );
}